import React from "react";
import { Helmet } from "react-helmet";
import SecondHeader from "../../Header/SecondHeader";
import Schedule from "./Schedule/Schedule";
import { useContext } from "react";
import { popupcontext } from "../../../context/Popupscontext";

const MaintenanceSchedule = () => {
  const { handleShow } = useContext(popupcontext);
  return (
    <>
      <Helmet>
        <title>Maintenance Schedules</title>
        <meta name="description" content="Maintenance Schedules" />
      </Helmet>
      <SecondHeader
        title="Maintenance Schedules"
        add="Add New Schedule"
        onClick={() => handleShow("addForm")}
      />
      <Schedule />
    </>
  );
};

export default MaintenanceSchedule;
